import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

export const IgHistogramChartSkeleton = () => {
  const theme = useTheme();
  const histogramData = [
    { name: "Page A", uv: 10 },
    { name: "Page B", uv: 23 },
    { name: "Page C", uv: 5 },
    { name: "Page C", uv: 34 },
    { name: "Page C", uv: 6 },
    { name: "Page C", uv: 13 },
    { name: "Page C", uv: 3 },
    { name: "Page C", uv: 14 },
    { name: "Page C", uv: 23 },
  ];
  return (
    <Grid>
      <ResponsiveContainer height={300} width="100%">
        <BarChart
          margin={{ top: 15, bottom: -10, right: -5, left: -20 }}
          data={histogramData}
          maxBarSize={60}
        >
          <CartesianGrid
            style={{ stroke: theme.igBorders.core.disabled }}
            vertical={false}
          />
          <XAxis
            interval={0}
            tick={false}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            tickLine={false}
            dataKey={"name"}
          />
          <YAxis
            tick={false}
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 12 }}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            tickLine={false}
          />
          <Bar
            fill={theme.igPrimitives.gray["A100"]}
            className="infinite-pulsing"
            dataKey="uv"
            radius={[3, 3, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Grid>
  );
};
